var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Auth',{on:{"loggedIn":_vm.loggedIn}},[_c('SignIn',{attrs:{"redirect":_vm.resultRedirect}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }